import { Project } from '../../entities/project';
import { type GitOrigin } from '../../models/GitOrigin';
import { TypeId } from '../../models/TypeId';
import { useCallback, useMemo } from 'react';
import { useEntity } from './entity-hooks';
import { useContext } from './useContext';

export function useProject(projectTypeId?: TypeId | null, options?: Parameters<typeof useEntity<Project>>[1]) {
  const context = useContext();
  const effectiveProjectTypeId = useMemo(() => {
    if (projectTypeId) return projectTypeId;
    return context.project?.typeId ?? null;
  }, [projectTypeId, context.project?.typeId]);
  const { data: project, isLoading, error } = useEntity<Project>(effectiveProjectTypeId, { watch: true, ...options });

  const setupComputeNode = useCallback(
    async (options?: { gitOrigin?: GitOrigin | null }) => {
      if (!project) {
        throw new Error('Project is not available');
      }
      await project.setupComputeNode(options);
    },
    [project],
  );

  return {
    project: project,
    isLoading: isLoading,
    error: error,
    setupComputeNode,
  };
}
